export class User {
	id: number;
	username: string;
	name: string;
	lastname: string;
	phone: string;
	email: string;
	description: string;
	last_login: string;
	is_admin: boolean;
	account_type: number;
	user_level: number;
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/domain-models/User.ts